@import "../../shared";

.icon-with-label {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 0.2rem 0;
  font-size: $font-size-itsy-bitsy;
  @media (min-width: $max-width-with-padding) {
    font-size: $font-size-small;
  }
}

.icon-with-label__icon {
  height: 2.4rem;
  width: 2.4rem;
  margin-bottom: 0.4rem;
  fill: $header-text-color;
  @media (min-width: $max-width-with-padding) {
    height: 2rem;
    width: 2rem;
  }
}

.icon-with-label__label {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: normal;
  line-height: 1;
  font-weight: $font-weight-regular;
}

.icon-without-label__icon {
  & .svg-outline {
    transition: fill 300ms ease;
    fill: white;
  }

  & .svg-fill {
    transition: fill 300ms ease;
    fill: transparent;
  }

  &--invert-color {
    & .svg-outline {
      fill: transparent;
    }

    & .svg-fill {
      fill: white;
    }
  }
}
